<div>
    <div class="box">
      <div class="drag-handle">
        <button (click)="onClickListaCapas()" class="circle-button">
          <div class="button-icon">
            <img *ngIf="this.layerCatalogService.isMapLayersVisible" [src]="'icon_capas_internas.svg' | findUrl" class="img-button">
            <img *ngIf="!this.layerCatalogService.isMapLayersVisible" [src]="'icon_capas_internas_gris.svg' | findUrl" class="img-button">
          </div>
        </button>
      </div>
      <div [@mostrarLista]="this.layerCatalogService.isMapLayersVisible ? 'visible' : 'hidden'" class="switch-list">
        <div class="tool-title">
          <h2>Capas De mapa</h2>
            <!-- <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false"  fontIcon="cancel" (click)="ClosePanel()"></mat-icon> -->
        </div>
        <div class="switch-item">
          <label class="switch" [id]='"layer-Traffic"'>
            <img *ngIf="this.panelMapLayerService.isTrafficLayer" [src]="'btn_on.svg' | findUrl" class="img-button" (click)="onToggleLayerTraffic()">
            <img *ngIf="!this.panelMapLayerService.isTrafficLayer" [src]="'btn_off.svg' | findUrl" class="img-button" (click)="onToggleLayerTraffic()">
          </label>
          <span>
            <!-- <img [src]="'nodes.png' | findUrl" class="img-layer">  -->
            Tráfico </span>
        </div>
    </div>
    </div>
  </div>